import AboutComponent from '../../ui/AboutComponent';
import BreadcrumbComponent from '../../ui/Breadcrumb';
import { Card } from '../../ui/TabBox';
import { Styles } from './styles';

export type AboutPageTemplateProps = {
  metaTitle?: string;
  metaDescription?: string;
  metaImage?: string;
  bannerTitle: string;
  bannerImg: string;
  title: string;
  description: string;
  valuesDescription: string;
  image: string;
  cards: Card[];
};

const AboutPageTemplate: React.FC<AboutPageTemplateProps> = ({
  bannerTitle,
  bannerImg,
  title,
  description,
  image,
  valuesDescription,
}) => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper about-page">
        <BreadcrumbComponent title={bannerTitle} image={bannerImg} />
        <AboutComponent
          title={title}
          description={description}
          image={image}
          valuesDescription={valuesDescription}
        />
        {/* {cards && <TabBox cards={cards} />} */}
      </div>
    </Styles>
  );
};

export default AboutPageTemplate;
